import { ContainerComponent, wrap } from 'AppReact';
import {
  Th, GenericWrapper, Mr2, MakeReadyPropertyCellWrapper,
  DivElementWithPopupWrapper, PopupWrapper, FlexCenterWrapper, My1, WhiteSpaceNoWrap
} from 'wrappers';
import { SecondaryTextXs300, SecondaryTextSm, ClickableDiv, Icon, WhiteTextSm, Empty } from 'atoms';
import { CheckboxSvg, EyeSvg, ExclamationMarkSvg } from 'components/icons';
import internalState from './internalState';
import Controller from './controller';

export const definition = {
  name: 'PropertyCell',
  controller: Controller,
  initialProps: ({ property, unit, isSelected, showSelectCheckbox, exceptions }) => ({ property, unit, isSelected, showSelectCheckbox, exceptions }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyPropertyCellWrapper,
      isButton: true,
      bindings: () => ({}),
      name: 'Wrapper',
      elements: [
        {
          component: wrap(ClickableDiv, Mr2),
          name: 'Checkbox',
          renderIf: ({ showSelectCheckbox }) => showSelectCheckbox,
          bindings: () => ({}),
          displayValue: ({ isSelected }) => CheckboxSvg({ checked: isSelected })
        },
        {
          wrapper: wrap(DivElementWithPopupWrapper, Mr2),
          renderIf: ({ exceptions }) => exceptions.length > 0,
          name: 'ErrorsWrapper',
          elements: [
            {
              component: Empty,
              name: 'Icon',
              displayValue: () => ExclamationMarkSvg({ width: 18, height: 18 })
            },
            {
              wrapper: PopupWrapper,
              name: 'PopupWrapper',
              displayState: ({ }) => ({ position: 'right', width: '400px', maxWidth: '400px' }),
              elements: [
                {
                  wrapper: wrap(FlexCenterWrapper, My1),
                  name: 'ElementWrapper',
                  isListOf: 'exceptions',
                  elements: [
                    {
                      component: WhiteTextSm,
                      name: 'Name',
                      displayValue: ({ exception }) => exception ?? ''
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          wrapper: GenericWrapper,
          name: 'PropertyWrapper',
          elements: [
            {
              component: SecondaryTextSm,
              name: 'Unit',
              displayValue: ({ unit }) => unit ?? ''
            },
            {
              component: SecondaryTextXs300,
              name: 'Property',
              displayValue: ({ property }) => property ?? ''
            }
          ]
        },
        {
          component: Icon,
          name: 'Eye',
          displayValue: () => EyeSvg({ width: 24, height: 24, noLine: true })
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), Th);
